module.exports = __webpack_public_path__ + "fonts/iconfont.bdc1501.woff2";